import { makeStyles } from "@material-ui/core";

const modalStyles = makeStyles((theme) => ({
  headerWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 0px",
    position: "relative",
    ...theme.borderBottom,
  },
  contentWrap: {
    padding: "16px",
  },
  footerWrap: {
    display: "flex",
    justifyContent: "flex-end",
    padding: `12px 15px`,
    ...theme.borderTop,
  },
}));

export default modalStyles;
